var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoXpens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    "data-name": "Layer 10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.59,5.92h6.37l4.38,6.59,4.29-6.59h6.19l-7.45,10.34,7.9,11.07h-6.46l-4.83-7.32-4.83,7.32H0l7.95-11.07L.59,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.95,5.92v2.8s2.03-3.34,6.46-3.34c5.56,0,10.43,4.65,10.43,11.25s-4.88,11.25-10.43,11.25c-3.39,0-5.33-1.85-6.05-2.76v12.6h-5.42V5.92h5.01Zm.41,13.91s1.54,2.98,5.1,2.98,5.87-2.66,5.87-6.19-2.21-6.19-5.87-6.19-5.1,2.98-5.1,2.98v6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.74,16.53c0,.41,0,1.22-.05,2.03h-15.99c.41,1.9,2.62,4.34,6.01,4.34,3.75,0,5.87-2.17,5.87-2.17l2.71,4.07s-3.39,3.07-8.58,3.07c-6.5,0-11.52-4.97-11.52-11.25s4.56-11.25,10.75-11.25,10.79,4.56,10.79,11.16Zm-5.42-1.9c-.09-1.85-1.81-4.34-5.38-4.34s-5.06,2.44-5.24,4.34h10.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.75,13.46v13.87h-5.42v-12.51c0-3.07-1.9-4.38-4.25-4.38-2.8,0-4.25,2.76-4.25,2.76v14.14h-5.42V5.92h5.06v3.12s1.9-3.66,6.41-3.66c4.16,0,7.86,2.94,7.86,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.97,20.05s2.85,3.07,6.46,3.07c2.21,0,4.07-.63,4.07-1.94,0-1.4-.99-1.67-4.25-2.35-4.25-.9-7.95-2.71-7.95-6.78,0-3.34,3.34-6.68,9.21-6.68,4.83,0,8.04,2.62,8.04,2.62l-2.71,3.98s-2.44-1.85-5.33-1.85c-2.03,0-3.88.72-3.88,2.03s1.45,1.63,5.06,2.39c4.25.9,7.27,2.3,7.27,6.73,0,3.66-3.88,6.59-9.35,6.59-6.28,0-9.67-3.88-9.67-3.88l3.03-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.08,20.73c1.99,0,3.57,1.58,3.57,3.57s-1.58,3.57-3.57,3.57-3.57-1.58-3.57-3.57,1.58-3.57,3.57-3.57Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.37.5h1.17l4.11,10.53h-1.32l-1.1-2.84h-4.54l-1.1,2.84h-1.35l4.14-10.53Zm-1.22,6.49h3.61l-1.81-4.68-1.81,4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m129.01.5h1.26v10.53h-1.26V.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoXpens);
export default __webpack_public_path__ + "static/media/logo-xpens.6163892571b7b3a7166e888f33c1fe7e.svg";
export { ForwardRef as ReactComponent };